import lessRequire from '../../config/less-require-resolver';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import { bindActionCreators } from 'redux';
import filter from 'lodash/filter';
import renderViewsState from '../shared/render-views-state';
import ModalBox from '../shared/modal';
import NotificationModal from './components/notification-modal';
import ProgressBar from './components/progress-bar';
import RankInfo from './components/rank-info';
import getRankData from '../shared/get-rank-data';

lessRequire('modules/ranks/main.less');

const Main = renderViewsState(props => {
	const { intl, isShowNotificationPopup, data, ranksList, rankGoods } = props;

	const { rank_id, points_total } = data;

	const points_per_month = data.points_per_month >= 0 ? data.points_per_month : 0;

	const actualRank = ranksList.find((rank) => rank.id === rank_id);
	const pointsRank = ranksList.find((rank) => points_per_month >= rank.pointsMin && points_per_month < rank.pointsMax);

	const isAllGiftsAreReceived = !filter(rankGoods, ({ good }) => !!good).length;

	const currentPointsMax = Math.round(pointsRank.pointsMax);

	const actualRankData = getRankData(actualRank.id, intl);

	return (
		<div className="dashboard container container__with-columns ranks_container">
			<ModalBox
				body={NotificationModal(props)}
				isOpen={isShowNotificationPopup}
				onClose={() => props.toggleRankPopup()}
				title={`${intl('Поздравлям, вы получили новый ранг')}!`}
				className={'notification__popup'}
			/>

			<div className="ranks font-proxima-nova-regular">
				<div className="container__content ranks-faq">
					<div className="current__rank">
						<div className="current__rank__info">
							<div>
								<div className="title font-museo-sans-medium">{intl('Текущая позиция')}</div>
								<div className="quid-container font-museo-sans-regular">
									<div className="monthly-quid">
										<span>{intl('QUID за этот месяц')}</span>
										<span>{Math.round(data.points_per_month)}</span>
									</div>
									<div className="total-quid">
										<span>{intl('QUID за все время')}</span>
										<span>{Math.round(points_total)}</span>
									</div>
								</div>
							</div>
							<div className="rank_preview font-museo-sans-regular">
								<div className="status">{intl('Ваш статус')}</div>
								<div className="current-status">{actualRankData.status.title}</div>
								<img className="current-rank__image" src={actualRankData.status.image} />
							</div>
						</div>
						<ProgressBar
							currentRank={actualRank}
							intl={intl}
							points_per_month={points_per_month}
							pointsLeft={currentPointsMax - points_per_month}
						/>
					</div>
				</div>
				<div className="terms font-museo-sans-regular">
					<div className="terms-description">
						<div className="title font-museo-sans-medium">
							{intl('Условия использования')}
						</div>
						<div className="column-1">
							{intl('QUID - самая что ни на есть настоящая космическая валюта, которая\
	расшифровывается как квазиуниверсальная интергалактическая деноминация\
	, сокращенно - куид (QUID). Именно так называются бонусы RocketProfit,\
	которые можно обменивать на крутые подарки в')
							}
							<Link to={'market'} className="blue-text"> store.rocketprofit.com.</Link>
						</div>
						<div className="column-2">
							{intl('Отныне каждому партнеру RocketProfit будет присвоен свой статус:') + ' '}
							<span className="blue-text">
								Beginner, Bronze, Silver, Gold, Diamond, Black Member.
							</span>
							<br/><br/><br/>
							{intl('Чем больше QUID вы заработали, тем выше статус, а вместе\
	сним и увеличивается сумма заработанных бонусов. Подостижению статуса всех\
	наших Бро ждут приятные подарки!'
							)}
						</div>
					</div>

					<div className='rank-head font-museo-sans-medium'>
						<div className='rank-head-status'>
							{intl('Статус')}
						</div>
						<div className='rank-head-description'>
							{intl('Условия')}
						</div>
						{!isAllGiftsAreReceived && (
							<div className='rank-head-gift'>
								{intl('Подарки')}
							</div>
						)}
					</div>
					<div className='rank-list'>
						{rankGoods.map(({ rankId, good }) => (
							<RankInfo
								rank={{ id: rankId, ...getRankData(rankId, intl) }}
								gift={good}
								key={rankId}
							/>
						))}
					</div>
				</div>
			</div>
		</div>
	);
});

export default connect(
	state => ({
		data: selectors.getData(state),
		rankGoods: selectors.getRankGoods(state),
		ranksList: selectors.getRanksList(state),
		isShowNotificationPopup: selectors.getIsShowNotificationPopupOn(state),
		intl: selectors.getIntl(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/ranks/main.js